import {
  AfterViewInit,
  Component,
  ElementRef,
  NgZone,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import { Router } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { capatelize } from '../SEO_Constant/routes.constant';
import { OurProductsMotionService } from './our-products-motion.service';

/**
 * Optional presentation metadata a product may carry.
 *
 * `image`, `tittle`, `details` and `rating` are the original fields and are the
 * only ones the routing and rating logic depend on. Everything below is additive
 * and rendered behind an `*ngIf`, so a product that has not been enriched yet
 * simply shows fewer chips — nothing breaks and nothing is invented.
 */
interface ProductCard {
  image: string;
  tittle: string;
  details: string;
  rating: number;
  /** Filter bucket. Drives the pill row and the solution rail. */
  category?: string;
  /** Tech stack chips, e.g. ['Angular', 'Node']. Left empty until confirmed. */
  tags?: string[];
  /** Release label, e.g. 'v2.4'. */
  version?: string;
  /** Deployment / client count, already formatted, e.g. '1.2k'. */
  installs?: string;
  /** Number of reviews behind the star rating. */
  reviews?: number;
  /** Starting price, already formatted, e.g. '₹49,000'. */
  price?: string;
  /** Public demo URL. When absent the card offers "Request demo" instead. */
  demoUrl?: string;
}

interface ProductFilter {
  id: string;
  label: string;
  count: number;
}

@Component({
    selector: 'app-our-products',
    templateUrl: './our-products.component.html',
    styleUrls: ['./our-products.component.css'],
    providers: [OurProductsMotionService],
    standalone: false
})
export class OurProductsComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild('opRoot') opRoot?: ElementRef<HTMLElement>;

  titles:any
  value = 5; //addition of .5
  starList: string[] = [];
  cardDetails : ProductCard[] = [
    {
      image:"assets/images/housieM.png",
      tittle:"HousieMania",
      details:"Introducing Housie Mania - Your Ultimate Tambola Housie Extravaganza!",
     rating : 5,
     category: 'mobile'

    },
    {
      image:"assets/images/sharpQ.png",
      tittle:"SharpQuiz",
      details:"Sharp Quiz - Master Your Programming Skills and General Knowledge.",
     rating : 4.8,
     category: 'education'

    },
    {
      image:"assets/images/ourproducts_ecommerce.png",
      tittle:"Ecommerce",
      details:"Enable a business to easily reach across geographic boundaries around the earth.",
      rating : 5,
      category: 'retail'

    },
    {
      image:"assets/images/ourproducts_grocery.png",
      tittle:"Grocery with Delivery system",
      details:"The user will search and look for grocery items or even local grocery stores nearby.",
      rating : 5,
      category: 'retail'

    },
    {
      image:"assets/images/ourproducts_food.png",
      tittle:"Food Ordering, Delivery System",
      details:" customers should be able to track their orders in real-time.",
      rating : 5,
      category: 'retail'

    },
    {
      image:"assets/images/ourproducts_school.png",
      tittle:"School Management",
      details:"This method can help the administration access the data instantly whenever required.",
      rating : 5,
      category: 'education'

    },
    {
      image:"assets/images/ourproducts_service.png",
      tittle:"Service Ordering System",
      details:"Allows technicians to receive real-time alerts and notifications for upcoming or past-due work orders.",
      rating : 5,
      category: 'erp'

    },
    {
      image:"assets/images/ourproducts_path.png",
      tittle:"Path Lab System",
      details:"Managing Tests & Cultures price list. Doctors management. Generating patient receipt.",
      rating : 5,
      category: 'healthcare'

    },
    {
      image:"assets/images/ourproducts_crm.png",
      tittle:"CRM and HRM",
      details:"Tickets can be raised by employees and clients which are assigned to ticket agents to get it resolved.",
      rating : 5,
      category: 'crm'

    },
    {
      image:"assets/images/ourproducts_digital.png",
      tittle:"Digital Visiting Card",
      details:"It’s a perfect way of networking and leaving your contact details to connect later on.",
      rating : 5,
      category: 'web'
    },
    {
      image:"assets/images/ourproducts_inventory.png",
      tittle:"Inventory and Billing",
      details:"Inventory and Billing Management software works as the heartbeat of any retail business.",
      rating : 5,
      category: 'erp'
    }
  ]
  bannercardDetails : any = [
    {
      image:"../../assets/images/housie-mania-logo.png",
      title:"Housie Mania",
      category:"mobile"
    },
    {
      image:"../../assets/images/sharpQuizLogo.png",
      title:"sharp Quiz",
      category:"education"
    },
    {
      image:"../../assets/images/eco.png",
      title:"Ecommerce",
      category:"retail"
    },
    {
      image:"../../assets/images/grocery.png",
      title:"Grocery",
      category:"retail"
    },
    {
      image:"../../assets/images/food.png",
      title:"Food",
      category:"retail"
    },
    {
      image:"../../assets/images/education.png",
      title:"Education",
      category:"education"
    },
    {
      image:"../../assets/images/service-order.png",
      title:"Order Service",
      category:"erp"
    },
    // {
    //   image:"../../assets/images/pathLab.png",
    //   title:"Path Lab"
    // },
    {
      image:"../../assets/images/social_media.png",
      title:"Social Media",
      category:"web"
    }
  ]

  /** Human labels for every filter bucket used above. */
  private readonly categoryLabels: Record<string, string> = {
    web: 'Web',
    mobile: 'Mobile',
    healthcare: 'Healthcare',
    education: 'Education',
    erp: 'ERP',
    crm: 'CRM',
    retail: 'Retail',
    ai: 'AI',
  };

  /** Built from the data, so a bucket with no products never renders a pill. */
  filters: ProductFilter[] = [];
  activeFilter = 'all';

  /** The rendered subset. Recomputed only on filter change, never in a getter. */
  visibleProducts: ProductCard[] = [];

  /** Marketplace counters. */
  readonly stats = [
    { to: 500, suffix: '+', label: 'Projects delivered' },
    { to: 250, suffix: '+', label: 'Clients served' },
    { to: 20, suffix: '+', label: 'Countries reached' },
    { to: 98, suffix: '%', label: 'Client satisfaction' },
  ];

  constructor(
    private title : Title,
    private router: Router,
    private motion: OurProductsMotionService,
    private zone: NgZone
  ) {
    this.titles = router.url.split('/')[router.url.split('/').length-1].replace(/-/g,' ')
    // console.log("cons",this.cardDetails)
  }

  ngOnInit(): void {
    this.title.setTitle(capatelize(this.titles) +' | Resiliencesoft')
    // console.log(this.cardDetails,"hii")

    this.buildFilters();
    this.visibleProducts = this.cardDetails;
  }

  ngAfterViewInit(): void {
    const root = this.opRoot?.nativeElement;
    if (!root) return;
    this.zone.runOutsideAngular(() => this.motion.init(root));
  }

  ngOnDestroy(): void {
    this.motion.destroy();
  }

  /* ------------------------------------------------------------- filtering -- */

  /** Derives the pill row from the products that actually exist. */
  private buildFilters(): void {
    const counts = new Map<string, number>();
    this.cardDetails.forEach((card) => {
      if (!card.category) return;
      counts.set(card.category, (counts.get(card.category) ?? 0) + 1);
    });

    this.filters = [
      { id: 'all', label: 'All', count: this.cardDetails.length },
      ...Object.keys(this.categoryLabels)
        .filter((id) => counts.has(id))
        .map((id) => ({
          id,
          label: this.categoryLabels[id],
          count: counts.get(id) as number,
        })),
    ];
  }

  setFilter(id: string): void {
    if (this.activeFilter === id) return;

    this.activeFilter = id;
    this.visibleProducts =
      id === 'all' ? this.cardDetails : this.cardDetails.filter((c) => c.category === id);

    // let the new set paint, then stagger it in
    this.zone.runOutsideAngular(() =>
      requestAnimationFrame(() => this.motion.revealCards())
    );
  }

  /** Solution rail card → matching filter, then scroll the catalogue into view. */
  selectSolution(item: any): void {
    if (item?.category) {
      this.setFilter(item.category);
    }
    this.scrollToCatalogue();
  }

  scrollToCatalogue(): void {
    const el = this.opRoot?.nativeElement?.querySelector('#op-catalogue');
    el?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  /** How many products sit in a solution rail card's bucket. */
  solutionCount(item: any): number {
    if (!item?.category) return 0;
    return this.cardDetails.filter((c) => c.category === item.category).length;
  }

  categoryLabel(id?: string): string {
    return id ? this.categoryLabels[id] ?? '' : '';
  }

  /* -------------------------------------------------- original logic, kept -- */

  getstarList(value: number): string[] {
    const starList: string[] = [];

    for (let i = 1; i <= 5; i++) {
      if (i <= value) {
        starList.push("fas fa-star");
      } else if (i <= value + 0.5) {
        starList.push("fas fa-star-half");
      } else {
        starList.push("far fa-star");
      }
    }

    return starList;
  }



  getUrl( card: any ){
    return { 'background-image': ` url('${card.image}') ` }
  }

  gotoDetail(detail:any){
    let name = detail.tittle.toLowerCase( ).split(" ")[0]
    this.router.navigateByUrl('/ourproducts/'+name)
  }

}
